import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = ["disabled"]

import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import SegmentedRadio from '@/components/forms/SegmentedRadio.vue'
import api from '@/store/api'
import { mapType } from '@/store/mappers'


export default {
  __name: 'NeueOrderModal',
  props: {
  isOpen: { type: Boolean, default: false },
  pair: { type: [String, Number], default: null }
},
  emits: ['closeModal'],
  setup(__props, { emit: __emit }) {

const ORDER_TYPES = [
  { label: 'New order', value: 'order' },
  { label: 'Custom invoice', value: 'invoice' }
]

const props = __props
const emit = __emit
const router = useRouter()

const storeOptions = computed(() => mapType('store').map(x => ({ name: x.attributes.store_name, value: x.id })))
const storesLoaded = ref(false)
const onlyStore = computed(() => (storesLoaded.value && storeOptions.value.length === 1 ? storeOptions.value[0] : null))

const tab = ref('order')
const store = ref(null)
const customer = ref(null)

watch(
  () => props.isOpen,
  () => {
    if (!props.isOpen) return // only reset on open to avoid flash when closing modal
    tab.value = 'order'
    store.value = onlyStore.value
    customer.value = null
  }
)

watch(onlyStore, option => {
  if (!store.value) store.value = option
})

const modalValid = computed(() => Boolean((props.pair || customer.value) && (store.value || tab.value === 'invoice')))

const search = async query => {
  const response = await api.call(
    'POST',
    'conversation_user_pairs/search',
    { search: { text: query } },
    { save: false }
  )
  return response.data.data.map(x => ({
    value: x.id,
    name: x.attributes.display_name
  }))
}

const create = () => {
  if (!modalValid.value) return
  api
    .call('POST', 'bottles', {
      bottle: {
        store_id: tab.value === 'order' ? store.value.value : undefined,
        type: tab.value === 'invoice' ? 'InvoiceBottle' : undefined,
        conversation_user_pair_id: props.pair || customer.value.value
      }
    })
    .then(response => {
      router.push('/order/' + response.data.data.id)
    })
  emit('closeModal')
}

onMounted(() => {
  api.call('GET', 'stores?included=none').then(() => {
    storesLoaded.value = true
  })
})

return (_ctx, _cache) => {
  const _component_ComboInput = _resolveComponent("ComboInput")
  const _component_TheModal = _resolveComponent("TheModal")

  return (_openBlock(), _createBlock(_component_TheModal, {
    "is-open": props.isOpen,
    "modal-title": "New order",
    "max-width": "max-w-sm",
    onCloseModal: _cache[4] || (_cache[4] = $event => (_ctx.$emit('closeModal')))
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SegmentedRadio, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((tab).value = $event)),
          label: "Type",
          options: ORDER_TYPES
        }, null, 8, ["modelValue"]),
        (!props.pair)
          ? (_openBlock(), _createBlock(_component_ComboInput, {
              key: 0,
              modelValue: customer.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((customer).value = $event)),
              name: "Customer",
              placeholder: "Type to search for a customer",
              option: customer.value,
              "query-function": search
            }, null, 8, ["modelValue", "option"]))
          : _createCommentVNode("", true),
        (tab.value === 'order')
          ? (_openBlock(), _createBlock(_component_ComboInput, {
              key: 1,
              modelValue: store.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((store).value = $event)),
              option: store.value,
              name: "Store",
              placeholder: "Type to search for a store",
              options: storeOptions.value
            }, null, 8, ["modelValue", "option", "options"]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn-ghost justify-center",
        type: "button",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('closeModal')))
      }, "Cancel"),
      _createElementVNode("button", {
        "data-test": "create-order",
        class: "btn-primary justify-center disabled:opacity-50 disabled:cursor-not-allowed",
        type: "button",
        disabled: !modalValid.value,
        onClick: create
      }, " Create ", 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

}